import { namespace } from 'vuex-class';
import { ICreateTemplateState } from '@/content-library/create-resource/template/store/create-template.types';

export const CreateTemplate = namespace('contentLibrary/createResource/createTemplate');

export const state: ICreateTemplateState = {
  createdTemplateId: null,
};

export enum ECreateTemplateAction {
  CreateTemplate = 'createTemplate',
  CreateTemplateFailed = 'createTemplateFailed',
  SetTemplateId = 'setTemplateId',
  Reset = 'reset',
}

export enum ECreateTemplateMutation {
  SetTemplateId = 'setTemplateId',
  SetState = 'setState',
}
